import React, { useEffect } from 'react'
import useTranslation from '../../shared/TranslationProvider'
import { useExercise } from '../ExerciseProvider'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../lib/ui/select'

const PartTwo = () => {
  const {
    exerciseIndex,
    trackContent,
    getDecisionMakingExerciseResponse,
    updateDecisionMakingExerciseResponse,
  } = useExercise()
  const { t } = useTranslation(
    `decision_making.pages.${exerciseIndex}.values-importance`,
  )

  useEffect(() => {
    let valueImportance = {}
    trackContent['selected_values'].map((value) => {
      valueImportance[value] = trackContent?.['value_importance']?.[value] || 3
    })
    updateDecisionMakingExerciseResponse('value_importance', valueImportance)
  }, [])

  const updateValueImportance = (value, importance) => {
    let valuesImportance =
      getDecisionMakingExerciseResponse('value_importance') || {}

    valuesImportance = { ...valuesImportance, [value]: importance }
    updateDecisionMakingExerciseResponse('value_importance', valuesImportance)
  }

  return (
    <>
      <h1>{t('title')}</h1>
      <p className="pb-4">{t('p1')}</p>
      <div className="questions flex flex-col items-center">
        <table className="importance-ranking w-1/2">
          <thead>
            <tr>
              <th>{t('value')}</th>
              <th>{t('importance')}</th>
            </tr>
          </thead>
          <tbody>
            {trackContent['selected_values'].map((value, idx) => (
              <tr key={idx} className="h-16">
                <td>{value}</td>
                <td>
                  <Select
                    onValueChange={(e) => updateValueImportance(value, e)}
                    value={
                      getDecisionMakingExerciseResponse('value_importance')
                        ? getDecisionMakingExerciseResponse('value_importance')[
                            value
                          ]
                        : ''
                    }
                    className="w-full rounded-[20px] border border-[#D3D3D3] bg-[#F7FAFC] p-3 font-roboto text-base"
                  >
                    <SelectTrigger className="sm:w-4/6">
                      <SelectValue placeholder="Select an option" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem key={'critical'} value={3}>
                        {t('critical')}
                      </SelectItem>
                      <SelectItem key={'important'} value={2}>
                        {t('important')}
                      </SelectItem>
                      <SelectItem key={'less_important'} value={1}>
                        {t('less_important')}
                      </SelectItem>
                    </SelectContent>
                  </Select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  )
}

export default PartTwo
